import { Conversation } from 'sb-lib/types';
import { useAppDispatch } from 'shared/store';
import { ChatMessage } from 'types/chat';
import {
  VISITOR_TYPING_CHAT_MESSAGE_ID,
  receivedConversationVisitorTypingMessage,
} from 'shared/store/chat-slice';

const isVisitorTypingMessage = (msg: ChatMessage) =>
  msg.id === VISITOR_TYPING_CHAT_MESSAGE_ID;

/**
 * Return whether the chat message is a "visitor typing" indicator.
 *
 * Schedules a followup check that cancels the typing status if the
 * message doesn't update for 15s. This covers the case where a
 * visitor client signals the is typing indicator, but then leaves before
 * turning it off for whatever reason.
 *
 * @param chatMessage
 * @returns
 */
const isTypingTimeoutsMap = new Map<Conversation['id'], number>();
export const useIsVisitorTyping = (chatMessage: ChatMessage) => {
  const dispatch = useAppDispatch();

  if (isVisitorTypingMessage(chatMessage)) {
    const { conversationId } = chatMessage;
    // Cancel typing after 15s in case visitor doesn't send stop typing message
    // 1. Cancel existing check
    clearTimeout(isTypingTimeoutsMap.get(conversationId) || 0);
    // 2. Schedule a new check
    isTypingTimeoutsMap.set(
      conversationId,
      window.setTimeout(() => {
        void dispatch(
          receivedConversationVisitorTypingMessage({
            conversationId,
            isTyping: false,
          }),
        );
      }, 15000),
    );

    return true;
  }
  return false;
};
